import React from "react";

import {
  IProductTemplateDropdownChangeEvent,
  ProductTemplateDropdown,
} from "components/basic/dropdowns/product-template/ProductTemplateDropdown";
import { IProductTemplateTableEditor } from "components/ComponentType";
import { InputSwitch, InputSwitchChangeEvent } from "primereact/inputswitch";
import { T } from "services/lang/LanguageService";
import { InputNumberValueChangeEvent } from "primereact/inputnumber";
import { MultiSelectChangeEvent } from "primereact/multiselect";
import ProductTemplateConfig from "./ProductTemplateConfig";

interface ProductTemplateGeneralConfigProps {
  currentConfig: IProductTemplateTableEditor;
  setCurrentConfig: React.Dispatch<React.SetStateAction<IProductTemplateTableEditor>>;
  handleConfigChange: (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | InputNumberValueChangeEvent
      | InputSwitchChangeEvent
      | MultiSelectChangeEvent
  ) => void;
}

const ProductTemplateGeneralConfig = ({
  currentConfig,
  setCurrentConfig,
  handleConfigChange,
}: ProductTemplateGeneralConfigProps) => {
  const safeNameSelectionHandler = (e: IProductTemplateDropdownChangeEvent) => {
    setCurrentConfig(prevState => ({ ...prevState, safeName: e.refName, id: e.value }));
  };

  return (
    <div className="grid p-fluid gap-3">
      <div className="flex flex-row w-full">
        <div className="w-full flex flex-column ">
          <label htmlFor="safeName">{T("word.safe-name")}</label>
          <ProductTemplateDropdown value={currentConfig.id} onChange={safeNameSelectionHandler} />
        </div>
        <div className="w-2 gap-2 flex flex-column align-items-center justify-content-center">
          <label htmlFor="transposed">{T("component.transposed")}</label>
          <InputSwitch
            id="transposed"
            checked={Boolean(currentConfig.transposed)}
            onChange={handleConfigChange}
          />
        </div>
      </div>
      <ProductTemplateConfig currentConfig={currentConfig} setCurrentConfig={setCurrentConfig} />
    </div>
  );
};

export default ProductTemplateGeneralConfig;
